/**
 * DetailPanel
 * - dynamically display the content selected in detail-selector
 * - pass property data as a prop to the selected detail view
 */
import React from 'react';
import { Theme } from '@mui/material/styles';
import { MyProperty } from '../property-detail';
import { ViewOption } from './property-detail-selector';
import { useIsLargeScreen } from '../../../system/SystemMediaQueriesProvider';

interface DetailPanelProps {
  theme: Theme;
  viewOption: ViewOption;
  data?: MyProperty;
}
export function DetailPanel(props: DetailPanelProps) {
  const { data, theme } = props;
  const isLarge = useIsLargeScreen();
  const Component = props.viewOption.view;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isLarge ? 'row' : 'column',
        flex: 1,
        alignItems: 'stretch',
        overflowY: isLarge ? 'scroll' : 'inherit',
        // maxHeight: isLarge ? 'calc(100vh - 206px)' : 'inherit',
      }}
    >
      <Component data={data} theme={theme} />
    </div>
  );
}
